<template>
  <div class="obj-major-info-content event-info">
    <el-row type="flex" justify="space-between" class="title-bar">
      <div>
        <span class="title">이벤트정보 - </span>
        <span style="font-size:13px; font-weight: 400; color: #444;">{{ title }}</span>
        <span v-if="isObj" @click="$emit('click-detail', `event-${eventType}`, isLan ? lanType : '')" style="cursor: pointer; font-size: 12px;"><i class="fas fa-external-link-alt"></i></span>
      </div>
      <!-- <el-radio-group v-model="eventType" v-if="!isEmptyPredictList" class="ordinary mr-b5" style="margin-top: 0px;">
        <el-radio-button label="status">이벤트 현황</el-radio-button>
        <el-radio-button label="predict">사전 예측 이벤트</el-radio-button>
      </el-radio-group> -->
      <el-switch
        v-if="!isEmptyPredictList"
        v-model="eventType"
        class="event-type-switch"
        size="small"
        inactive-text="현황"
        active-text="예측"
        inactive-value="status"
        active-value="predict"
        inactive-color="#38608e"
        active-color="#38608e"
      >
      </el-switch>
    </el-row>
    <div class="event-info-content-wrapper">
      <div class="table" :style="{ height: fitHeight ? 'calc(100% - 20px)' : null }">
        <div class="event-info-content-subtitle content-between">
          <span>
          </span>
          <!-- <span class="more-btn" v-if="isObj" @click="$emit('click-detail', `event-${eventType}`)">상세보기</span> -->
          <!-- <el-button v-if="!isSubMap" size="mini" type="secondary" @click="$emit('click-detail', `event-${eventType}`)">더보기</el-button> -->
        </div>
        <el-table
          :data="eventType === MapConst.EVENT_TYPE.STATUS ? statusList : predictList"
          :height="fitHeight ? '100%' : null"
          style="width: 100%"
          class="popup"
          v-loading="isLoading"
          >
          <el-table-column
            v-for="column in columns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :align="column.align"
            >
            <template slot-scope="scope">
              <w-eventlevel-cell v-if="column.scopedSlot === 'eventlevel-slot'" mini :eventlevel-id="scope.row.eventlevelId"/>
              <span v-else-if="column.scopedSlot === 'objName-slot'">
                {{ scope.row.objName }}
              </span>
              <span v-else-if="column.scopedSlot === 'event-message-slot'">
                <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
                  동적
                </div>
                <a href="#" @click="clickEventMessage(scope.row)" class="click-item">{{scope.row.eventMessage}}</a>
              </span>
              <span v-else-if="column.scopedSlot === 'check-datetime-slot'">{{getDateFormatter(scope.row[scope.column.property])}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';

import Base from '@/mixins/topologymap/base';

import WEventlevelCell from '@/components/table/EventlevelCell';

import MapConst from '@/constants/topologymap';

import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { openFaultAnalysisPopup } from '@/utils/event';

export default {
  name: 'WCommonEventInfoView',
  components: {
    WEventlevelCell,
  },
  mixins: [Base],
  props: {
    /**
     * 하위맵과 사용자정의위젯을 제외한 관리대상
     * @type {Object}
     */
    isObj: {
      type: Boolean,
      default: true,
    },
    fitHeight: {
      type: Boolean,
      default: false,
    },
    isLan: {
      type: Boolean,
      default: false,
    },
    lanType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      MapConst,
      eventType: MapConst.EVENT_TYPE.STATUS,
      /**
       * 테이블 로딩 플래그
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * 현황 이벤트 리스트 데이터
       * @type {Array}
       */
      statusList: [],
      /**
       * 사전 예측 이벤트 리스트 데이터
       * @type {Array}
       */
      predictList: [],
      /**
       * 사전 예측 이벤트의 null 여부 확인 플래그
       * @type {Boolean}
       */
      isEmptyPredictList: true,
      objDefineId: '',
      /**
       * 컬럼
       * @type {Object}
       */
      eventListColumn: {
        eventlevelName: {
          prop: 'eventlevelName',
          label: '등급',
          width: 75,
          columnKey: 'eventlevelId',
          className: 'eventlevel',
          scopedSlot: 'eventlevel-slot',
          resizable: false,
        },
        objName: {
          prop: 'objName',
          label: '대상',
          width: 90,
          columnKey: 'objName',
          className: 'objName',
          scopedSlot: 'objName-slot',
          resizable: false,
        },
        eventMessage: {
          prop: 'eventMessage',
          label: '장애메시지',
          scopedSlot: 'event-message-slot',
          resizable: false,
        },
        statusCheckDatetime: {
          prop: 'checkDatetime',
          label: '발생시각',
          width: 90,
          scopedSlot: 'check-datetime-slot',
          resizable: false,
        },
        predictCheckDatetime: {
          prop: 'checkDatetime',
          label: '예상발생시각',
          width: 90,
          scopedSlot: 'check-datetime-slot',
          resizable: false,
        },
      },
    };
  },
  computed: {
    title() {
      return (this.eventType === MapConst.EVENT_TYPE.STATUS) ? '이벤트 현황' : '사전 예측 이벤트';
    },
    /**
     * 선택 된 모델에 따른 컬럼 반환
     * @author KangBonghun(toto1323)
     * @return {Array} 컬럼
     */
    columns() {
      const { eventlevelName, objName, eventMessage, statusCheckDatetime, predictCheckDatetime } = this.eventListColumn;

      const columns = [];
      columns.push(eventlevelName);
      if (!this.isObj) {
        columns.push(objName);
      }
      columns.push(eventMessage);
      columns.push((this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime);
      return columns;
    },
  },
  methods: {
    /**
     * 데이터 초기화 (요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} eventList   [description]
     * @param  {[type]} eventType   [description]
     * @param  {[type]} objDefineId [description]
     */
    setData(eventList, eventType, objDefineId) {
      // this.eventType = eventType;
      this.objDefineId = objDefineId;
      if (eventType === MapConst.EVENT_TYPE.STATUS) {
        this.statusList = eventList;
      } else {
        this.predictList = eventList;
        this.isEmptyPredictList = (eventList.length === 0);
      }
    },
    /**
     * 데이터 초기화 (기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.eventType = MapConst.EVENT_TYPE.STATUS;
      this.statusList = [];
      this.predictList = [];
      this.isEmptyPredictList = false;
    },
    /**
     * 날짜데이터 포매터
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    /**
     * 장애메시지 클릭시 장애 연계
     * @author KangBonghun(toto1323)
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickEventMessage(selectedEventRow) {
      openFaultAnalysisPopup(selectedEventRow.eventSeqNumber);
    },
  },
};
</script>
<style lang="scss">
.event-type-switch {
  margin-top: 5px;

  .el-switch__label * {
    font-size: 13px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/CommonEventInfoView.vue